import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import P2 from '@base/P2/P2';
import { useState } from 'react';

import AuthorHeader from './AuthorHeader';
import Card from './Card';
import Dialog from '../Dialog/Dialog';

const Container = styled.div`
  width: 100%;
  height: auto;
`;

const Message = styled(P2)`
  color: var(--color-text-primary);
  font-size: 12px;
  line-height: 150%;
  margin-bottom: 12px;
`;

const Image = styled.img`
  border: 1px solid var(--color-divider);
  border-radius: 4px;
  cursor: ${({ pointer }) => pointer};
`;

const ImageWrapper = styled.div`
  background-color: var(--color-base-0);
  padding: 24px;
`;

const StyledCard = styled(Card)`
  margin-top: 16px;
`;

const ImageCard = ({ story, batch }) => {
  const [openImg, setOpenImg] = useState(false);

  return (
    <Container>
      <AuthorHeader
        subtitle={batch && story?.object?.collection_name}
        author={story.author}
        created_at={story.created_at}
      />
      <StyledCard>
        {!!story.message && <Message>{story.message}</Message>}
        <Image
          width="100%"
          src={story.object_meta}
          onClick={() => setOpenImg(true)}
          pointer="pointer"
          alt={story.message}
        />
      </StyledCard>
      <Dialog center onClose={() => setOpenImg(false)} dialogState={openImg}>
        <ImageWrapper>
          <Image
            width="100%"
            src={story.object_meta}
            onClick={() => setOpenImg(true)}
            pointer="auto"
            alt={story.message}
          />
        </ImageWrapper>
      </Dialog>
    </Container>
  );
};

export default ImageCard;

ImageCard.propTypes = {
  story: PropTypes.objectOf(PropTypes.any).isRequired,
  batch: PropTypes.bool
};

ImageCard.defaultProps = {
  batch: false
};
